import buildResourceActions from 'store/configure/actions';

const resourceActions = buildResourceActions('conversationsV2');

export default resourceActions;
